// extracted by css-extract-rspack-plugin
export default {"parent":"lFr46","close":"H6uHz"};